import { Button, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../features/userSlice";
import { sendUserNotification } from "../../utilities";
import Autocomplete from "@mui/material/Autocomplete";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import CheckUserAdmin from "../../components/User/CheckUserAdmin";
import NotificationAddIcon from "@mui/icons-material/NotificationAdd";
import SendIcon from "@mui/icons-material/Send";
import { PageHeader, PageShell } from "../../components/UI/Page";
import { LoadingState } from "../../components/UI/States";

const CreateNotification = () => {
  const user = useSelector(selectUser);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState();
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");
  const [link, setLink] = useState("");
  const [notificationSent, setNotificationSent] = useState(false);

  const getAllUsers = () => {
    return fetch("/api/getUserID")
      .then((response) => response.json())
      .then((responseJson) => {
        setUsers(responseJson.recordset);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  useEffect(() => {
    getAllUsers();
  }, []);

  const handleSubjectChange = (event) => {
    setSubject(event.target.value);
  };

  const handleBodyChange = (event) => {
    setBody(event.target.value);
  };

  const handleLinkChange = (event) => {
    setLink(event.target.value);
  };

  const handleChange = (event, value) => {
    setSelectedUser(value);
  };

  const handleSendNotification = () => {
    if (subject.trim() === "") {
      <Alert variant="filled" severity="error">
        <AlertTitle>
          <p className="text-white">Subject is empty!</p>
        </AlertTitle>
      </Alert>;
      return;
    }

    if (body.trim() === "") {
      <Alert variant="filled" severity="error">
        <AlertTitle>
          <p className="text-white">Body is empty!</p>
        </AlertTitle>
      </Alert>;

      return;
    }

    const emailAddress = selectedUser ? selectedUser.EmailAddress : "";
    sendUserNotification(emailAddress, user.name, body, subject, link);
    setBody("");
    setSubject("");
    setLink("");
    setNotificationSent(true);
    setTimeout(() => {
      setNotificationSent(false);
    }, 3000);
  };

  return (
    <PageShell size="md">
      <CheckUserAdmin />
      <PageHeader
        icon={NotificationAddIcon}
        tone="slate"
        eyebrow="Admin"
        title="Create Notification"
        description="Send an in-app notification to one person. It shows in their header bell and on their homepage."
      />

      {users.length > 0 ? (
        <div className="space-y-6">
          <div className="app-card rounded-2xl border p-5 sm:p-6">
            <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
              <div className="flex flex-col gap-1.5 sm:col-span-2">
                <label
                  htmlFor="notification-user"
                  className="text-sm font-semibold"
                >
                  Select User
                </label>
                <Autocomplete
                  id="notification-user"
                  value={selectedUser}
                  options={users}
                  getOptionLabel={(item) => item.Name}
                  onChange={handleChange}
                  renderInput={(params) => (
                    <TextField {...params} size="small" value={""} />
                  )}
                />
              </div>
              <div className="flex flex-col gap-1.5">
                <label htmlFor="subject" className="text-sm font-semibold">
                  Subject
                </label>
                <TextField
                  id="subject"
                  size="small"
                  placeholder="Subject"
                  variant="outlined"
                  value={subject}
                  onChange={handleSubjectChange}
                />
              </div>
              <div className="flex flex-col gap-1.5">
                <label htmlFor="link" className="text-sm font-semibold">
                  Link
                </label>
                <TextField
                  id="link"
                  size="small"
                  placeholder="Link"
                  variant="outlined"
                  value={link}
                  onChange={handleLinkChange}
                />
                <p className="app-muted text-xs">
                  Optional — a page on the site to open, e.g. /help.
                </p>
              </div>
              <div className="flex flex-col gap-1.5 sm:col-span-2">
                <label htmlFor="body" className="text-sm font-semibold">
                  Body
                </label>
                <TextField
                  id="body"
                  placeholder="Body"
                  variant="outlined"
                  multiline={true}
                  minRows={4}
                  value={body}
                  onChange={handleBodyChange}
                />
              </div>
            </div>

            <div className="mt-6 flex flex-col-reverse gap-3 border-t app-divider pt-5 sm:flex-row sm:items-center sm:justify-between">
              <div>
                {notificationSent && (
                  <Alert variant="filled" severity="success">
                    <AlertTitle sx={{ m: 0 }}>
                      <p className="text-white">Notification Sent!</p>
                    </AlertTitle>
                  </Alert>
                )}
              </div>
              <Button
                variant="contained"
                endIcon={<SendIcon />}
                onClick={handleSendNotification}
              >
                Send Notification!
              </Button>
            </div>
          </div>

          <div className="flex flex-wrap gap-2 opacity-80">
            <a
              href="https://data.typeracer.com/pit/profile?user=nathankvb&ref=badge"
              target="_top"
            >
              <img
                src="https://data.typeracer.com/misc/badge?user=nathankvb"
                border="0"
                alt="TypeRacer.com scorecard for user nathankvb"
              />
            </a>

            <a
              href="https://data.typeracer.com/pit/profile?user=blake243&ref=badge"
              target="_top"
            >
              <img
                src="https://data.typeracer.com/misc/badge?user=blake243"
                border="0"
                alt="TypeRacer.com scorecard for user blake243"
              />
            </a>
          </div>
        </div>
      ) : (
        <LoadingState label="Loading users…" />
      )}
    </PageShell>
  );
};

export default CreateNotification;
